<template>
  <b-card class="shadow-none rounded rounded-3 flex-fill mb-3">
    <div class="d-flex align-items-stretch">
      <div
        class="user-avatar d-flex flex-column justify-content-between"
      >
        <b-avatar
          size="6rem"
          :src="customer.data ? customer.data.pictureUrl : customer.avatar_url"
        ></b-avatar>

        <div
          v-if="$permissions.has($permissions.consts.CUSTOMER_LIST_EDIT)"
          class="text-center m-auto"
        >
          <b-button
            class="flex-shrink-0"
            variant="inverse-warning"
            :to="{
              name: 'CustomerDetailEdit',
              params: { customerID: customer.id },
            }"
          >
            編輯
          </b-button>
        </div>
      </div>
      <div class="wrapper pl-4 flex-fill">
        <div class="wrapper d-flex align-items-center justify-content-between">
          <a role="button" :class="showUnderline ? 'customer-name-underline' : 'customer-name'" @click="handleRedirectCustomer(customer.id)">
            <h4 class="mb-1 text-xl font-weight-medium">
              {{ customer.name }}
            </h4>
          </a>
          <template v-if="merchantTypeName">
            <span :id="`merchant-${customer.id}`" class="badge badge-primary badge-pill text-wrap">{{ merchantTypeName.substring(0,25) }}</span>
            <b-tooltip :target="`merchant-${customer.id}`" placement="top">{{ merchantName }}</b-tooltip>
          </template>
        </div>
        <div
          class="
            wrapper
            d-flex
            align-items-center
            font-weight-medium
            text-muted
          "
        >
          <i :id="`icon-account-card-details-${customer.id}`" class="mdi mdi-account-card-details mr-2"></i>
          <b-tooltip :target="`icon-account-card-details-${customer.id}`" placement="left">識別編號</b-tooltip>
          <p class="mb-0 text-muted text-sm" style="line-break: anywhere">
            {{ customer.outer_code }}
          </p>
        </div>
        <div
          class="
            wrapper
            d-flex
            align-items-center
            font-weight-medium
            text-muted
          "
        >
          <i :id="`icon-cellphone-${customer.id}`" class="mdi mdi-cellphone mr-2"></i>
          <b-tooltip :target="`icon-cellphone-${customer.id}`" placement="left">手機</b-tooltip>
          <p class="mb-0 text-muted text-sm">
            {{ customer.mobile_phone }}
            <span
              v-if="customer.phone_verified_at"
              id="icon-phone-verified"
              class="mdi mdi-verified"
              style="color: #009100;"
            ></span>
            <b-tooltip
              v-if="customer.phone_verified_at"
              target="icon-phone-verified"
              placement="right"
            >
              手機驗證時間：{{ moment(customer.phone_verified_at).format('YYYY-MM-DD HH:mm') }}
            </b-tooltip>
          </p>
        </div>
        <div
          class="
            wrapper
            d-flex
            align-items-center
            font-weight-medium
            text-muted
          "
        >
          <i :id="`icon-email-outline-${customer.id}`" class="mdi mdi-email-outline mr-2"></i>
          <b-tooltip :target="`icon-email-outline-${customer.id}`" placement="left">E-mail</b-tooltip>
          <p class="mb-0 text-muted text-sm" style="line-break: anywhere">{{ customer.email }}</p>
        </div>
        <div
          class="
            wrapper
            d-flex
            align-items-center
            font-weight-medium
            text-muted
          "
        >
          <i :id="`icon-gender-male-female-${customer.id}`" class="mdi mdi-gender-male-female mr-2"></i>
          <b-tooltip :target="`icon-gender-male-female-${customer.id}`" placement="left">性別</b-tooltip>
          <p class="mb-0 text-muted text-sm">{{ customer.sexual }}</p>
        </div>
        <div
          class="
            wrapper
            d-flex
            align-items-center
            font-weight-medium
            text-muted
          "
        >
          <i :id="`icon-cake-variant-${customer.id}`" class="mdi mdi-cake-variant mr-2" ></i>
          <b-tooltip :target="`icon-cake-variant-${customer.id}`" placement="left">生日</b-tooltip>
          <p class="mb-0 text-muted text-sm">{{ customer.birthday ? moment(customer.birthday).format('YYYY-MM-DD') : '' }}</p>
        </div>
        <div
          class="
            wrapper
            d-flex
            align-items-center
            font-weight-medium
            text-muted
          "
        >
          <i :id="`icon-account-plus-${customer.id}`" class="mdi mdi-account-plus mr-2" ></i>
          <b-tooltip :target="`icon-account-plus-${customer.id}`" placement="left">加入時間</b-tooltip>
          <p class="mb-0 text-muted text-sm">{{ customer.created_at ? moment(customer.created_at).format('YYYY-MM-DD HH:mm') : '' }}</p>
        </div>
        <div
          class="
            wrapper
            d-flex
            align-items-center
            font-weight-medium
            text-muted
          "
        >
          <i :id="`icon-account-check-${customer.id}`" class="mdi mdi-account-check mr-2" ></i>
          <b-tooltip :target="`icon-account-check-${customer.id}`" placement="left">註冊時間</b-tooltip>
          <p class="mb-0 text-muted text-sm">
            {{ customer.registered_at ? moment(customer.registered_at).format('YYYY-MM-DD HH:mm') : '' }}
            <span v-if="customer.registered_at" class="mdi mdi-verified" style="color: #009100;"></span>
          </p>
        </div>

        <div class="text-right mt-2">
          <b-button v-if="showCanRecomputeLevel" class="m-1" variant="inverse-success" @click="recomputeLevel(customer)"  ><i class="mdi mdi-flask-outline m-1">重新計算等級</i></b-button>
          <b-button v-if="merchantType=='LINE' && $permissions.has($permissions.consts.CUSTOMER_LINE_SYNC)" class="m-1" variant="inverse-success" @click="handleSyncLineData(customer)"  ><i class="mdi mdi-cloud-download"></i>同步 LINE</b-button>
          <b-button v-if="merchantType=='LINE' && $permissions.has($permissions.consts.CUSTOMER_LINE_SYNC)" class="m-1" variant="inverse-warning" @click="handleClearLiffCache(customer)"  ><i class="mdi mdi-cloud-sync"></i>清除快取</b-button>
          <b-button
            v-if="showQuicklyUnbind"
            class="m-1"
            variant="outline-danger"
            v-b-tooltip.hover
            title="重設此帳號，並解除所有綁定"
            @click="handleQuicklyUnbind(customer)"
          >
            <i class="mdi mdi-link-off"></i> 快速解綁
          </b-button>
          <b-button
            v-if="showUnregister"
            class="m-1"
            variant="outline-danger"
            v-b-tooltip.hover
            title="將此帳號設定為未註冊狀態"
            @click="handleUnregister(customer)"
          >
            <span class="mdi mdi-logout"></span> 重新註冊
          </b-button>
          <b-button
            v-if="showDeleteButton"
            class="m-1"
            variant="outline-danger"
            @click="handlePermanentDelete"
          >
            <i class="mdi mdi-delete"></i> 永久刪除
          </b-button>
          <b-button
            v-if="showSoftDeleteButton"
            class="m-1"
            variant="outline-warning"
            @click="handleSoftDelete"
          >
            <i class="mdi mdi-minus-circle"></i> 刪除會員
          </b-button>
          <b-button
            v-if="$permissions.has($permissions.consts.CUSTOMER_EDIT_VERRIFY_PHONE)"
            class="m-1"
            variant="outline-danger"
            @click="phoneNumberToVerify = customer.mobile_phone; $refs['modal-manually-verify-phone'].show()"
          >
            <span class="mdi mdi-cellphone"></span> 驗證手機
          </b-button>
          <b-button
            v-if="merchantType=='LINE' && $permissions.has($permissions.consts.CUSTOMER_EDIT_RESET)"
            class="m-1"
            variant="outline-danger"
            v-b-tooltip.hover
            title="重設此帳號，並刪除所有綁定"
            @click="handleReset(customer)"
          >
            <i class="mdi mdi-autorenew"></i> 帳號重設
          </b-button>
          <template v-if="showUnbindButton && $permissions.has($permissions.consts.CUSTOMER_EDIT_UNBIND) && merchantType !== 'LINE'">
            <span :id="`unbind-${customer.id}`">
              <b-button variant="outline-danger" @click="handleUnbind(customer)" :disabled="merchantType=='LINE'" >
                <i class="mdi mdi-link-off"></i>解除綁定
              </b-button>
            </span>
            <b-tooltip v-if="merchantType=='LINE'" :target="`unbind-${customer.id}`" placement="top">LINE 通路無法解除綁定</b-tooltip>
            <b-tooltip v-else :target="`unbind-${customer.id}`" placement="top">解除此帳號的綁定</b-tooltip>
          </template>
        </div>
      </div>
    </div>
    <b-modal ref="modal-manually-verify-phone" title="手機驗證">
      <b-overlay :show="isVerifyingPhone">
        <b-form-group
          label-cols="12"
          label-cols-lg="3"
          label-size="m"
          label="手機號碼"
        >
          <b-form-input v-model="phoneNumberToVerify"></b-form-input>
        </b-form-group>
      </b-overlay>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-danger"
          size="sm"
          class="float-right"
          @click="cancel()"
        >
          關閉
        </b-button>
        <b-button
          variant="outline-primary"
          size="sm"
          class="float-right"
          @click="handleManuallyVerifyPhoneIsClicked(phoneNumberToVerify)"
          :disabled="!phoneNumberToVerify"
        >
          確定
        </b-button>
      </template>
    </b-modal>
  </b-card>
</template>

<script>
import customerApi from "@/apis/customer";
import moment from 'moment'
import * as consts from "@/consts";

export default {
  props: {
    customer: {
      type: Object,
      required: true,
    },
    showUnbindButton: {
      type: Boolean,
      default: false,
    },
    showUnderline: {
      type: Boolean,
      default: false,
    },
    showDeleteButton: {
      type: Boolean,
      default: false,
    },
    showSoftDeleteButton: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isVerifyingPhone: false,
      phoneNumberToVerify: '',
    }
  },
  computed: {
    merchantName() {
      return this.customer.merchant ? this.customer.merchant.name : this.customer.merchant_type_name.name;
    },
    merchantType() {
      return this.customer.merchant ? this.customer.merchant.type : this.customer.merchant_type_name.type;
    },
    merchantTypeName() {
      return this.customer.merchant ? this.customer.merchant.type_name : this.customer.merchant_type_name.type_name;
    },
    showQuicklyUnbind() {
      return this.merchantType == consts.MERCHANT_TYPES.LINE_TYPE && this.$permissions.has(this.$permissions.consts.CUSTOMER_EDIT_UNBIND_CLEAR)
    },
    showUnregister() {
      return this.merchantType == consts.MERCHANT_TYPES.LINE_TYPE && this.$permissions.has(this.$permissions.consts.CUSTOMER_EDIT_UNREGISTER)
    },
    showCanRecomputeLevel() {
      return this.customer?.loyalty?.level_name && (this.merchantType == consts.MERCHANT_TYPES.LINE_TYPE) && this.$permissions.has(this.$permissions.consts.CUSTOMER_LEVEL_RECOMPUTE)
    },
    moment () {
      return moment
    },
  },
  methods: {
    handleRedirectCustomer(id) {
      console.log('handleRedirectCustomer', id)
      this.$router.push({
        name: 'CustomerDetailView',
        params: {
          customerID: id,
          org_code: this.$route.params.org_code
        },
      }, ()=> { this.$emit("trigger-init-data") })
    },
    async handleSyncLineData(customer) {
      await customerApi.syncLineData(customer.id).then((response) => {
        if (response.data.success) {
          this.$swal("成功", "同步成功", "success").then(() => {
            this.$emit("trigger-fetch-customer");
          });
        } else {
          this.$swal("失敗", "同步失敗，請聯絡系統管理員", "warning");
        }
      });
    },
    async handleClearLiffCache(customer) {
      try {
        const response = await customerApi.clearLiffCache(customer.id);
        if (response.data.status === 'success') {
          this.$swal("成功", "快取已清除", "success");
        } else {
          this.$swal("失敗", "清除快取失敗，請聯絡系統管理員", "warning");
        }
      } catch (error) {
        this.$swal("失敗", "清除快取失敗，請聯絡系統管理員", "error");
      }
    },
    async handleUnbind(customer) {
      try {
        this.$swal
          .fire({
            type: "warning",
            title: `您確定要將 ${customer.name} 解除綁定嗎？`,
            confirmButtonText: "確定解除綁定",
            cancelButtonText: "取消",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            reverseButtons: true,
          })
          .then(async (result) => {
            if (result.value) {
              try {
                const response = await customerApi.unbind(customer.id);
                if (response.status === 200) {
                  await this.$swal.fire({
                    title: "成功",
                    type: "success",
                    text: "解除綁定成功",
                  });
                  this.$emit("trigger-init-data");
                }
              } catch (error) {
                this.$swal("失敗", error.response.data.message, "error");
              }
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
    async handleReset(customer) {
      try {
        this.$swal
          .fire({
            type: "warning",
            title: `您確定要將所有與 ${customer.name} 相關的綁定資料刪除嗎？`,
            confirmButtonText: "確定刪除所有綁定",
            cancelButtonText: "取消",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            reverseButtons: true,
          })
          .then(async (result) => {
            if (result.value) {
              try {
                const response = await customerApi.reset(customer.id);
                if (response.status === 200) {
                  await this.$swal.fire({
                    title: "成功",
                    type: "success",
                    text: "刪除綁定成功",
                  });
                  this.$emit("trigger-init-data");
                }
              } catch (error) {
                this.$swal("失敗", error.response.data.message, "error");
              }
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
    async handleQuicklyUnbind(customer) {
      try {
        const html = `
          確定要解綁此帳號嗎？<br>
          會恢復為未註冊狀態，並解除所有的綁定帳號。
        `
        this.$swal
          .fire({
            type: "warning",
            html,
            confirmButtonText: "確認解綁",
            cancelButtonText: "取消",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            reverseButtons: true,
          })
          .then(async (result) => {
            if (result.value) {
              try {
                const response = await customerApi.quicklyUnbind(customer.id);
                if (response.status === 200) {
                  await this.$swal.fire({
                    title: "成功",
                    type: "success",
                    text: "解綁成功",
                  });
                   this.$emit("trigger-init-data");
                }
              } catch (error) {
                this.$swal("失敗", error.response.data.message, "error");
              }
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
    async handleUnregister(customer) {
      try {
        this.$swal
          .fire({
            type: "warning",
            title: `確定要將此帳號 ${customer.name} 設定為未註冊嗎？`,
            text: '會清除帳號的手機號碼、與註冊時間。',
            confirmButtonText: "確認重設",
            cancelButtonText: "取消",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            reverseButtons: true,
          })
          .then(async (result) => {
            if (result.value) {
              try {
                const response = await customerApi.unregister(customer.id);
                if (response.status === 200) {
                  await this.$swal.fire({
                    title: "成功",
                    type: "success",
                    text: "重設成功",
                  });
                  this.$emit("trigger-fetch-customer");
                }
              } catch (error) {
                this.$swal("失敗", error.response.data.message, "error");
              }
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
    async recomputeLevel(customer) {
      await customerApi.recomputeLevel(customer.id).then((response) => {
        if (response.data.status == 'success') {
          this.$swal("成功", "會員等級計算更新成功", "success").then(() => {
            this.$emit("trigger-fetch-customer");
          });
        } else {
          this.$swal("失敗", "計算更新失敗，請聯絡系統管理員", "warning");
        }
      });
    },
    async handleManuallyVerifyPhoneIsClicked(mobilePhone) {
      try {
        this.isVerifyingPhone = true;
        await customerApi.manuallyVerifyPhone(this.customer.id, mobilePhone);
        this.$swal("成功", "手機驗證完成", "success");
        this.$refs['modal-manually-verify-phone'].hide();
        this.$emit("trigger-fetch-customer");
      } catch (error) {
        console.log(error);
        this.$swal("失敗", "手機驗證失敗", "error");
      } finally {
        this.isVerifyingPhone = false;
      }
    },
    async handlePermanentDelete() {
      try {
        const result = await this.$swal({
          title: '永久刪除會員帳號',
          html: `注意：<strong style="color: #d33; font-size: 1.1em;">${this.customer.name}</strong> 帳號一旦永久刪除，相關資訊將無法回復。<br><br>` +
                `請輸入下方 <strong>識別編號</strong> 以確認操作：<br>` +
                `<div style="margin-top: 10px; padding: 5px; text-align: center;">` +
                `<span id="outer-code-copy-btn-1" onclick="navigator.clipboard.writeText('${this.customer.outer_code}').then(function(){ document.getElementById('outer-code-copy-btn-1').innerText = '已複製 ✔'; setTimeout(function(){ document.getElementById('outer-code-copy-btn-1').innerText = '${this.customer.outer_code}'; }, 1500); })" style="background-color: #f4f6f8; border: 1px dashed #ccc; padding: 4px 8px; border-radius: 4px; font-size: 1rem; font-weight: bold; color: #d33; letter-spacing: 1px; cursor: pointer; display: inline-block; min-width: 140px; user-select: none; transition: 0.3s;" title="點擊即可複製">${this.customer.outer_code}</span>` +
                `<div style="margin-top: 8px; font-size: 0.85rem; color: #888;">點擊上方編號即可自動複製</div></div>`,
          type: 'warning',
          input: 'text',
          inputPlaceholder: '請輸入識別編號',
          inputValidator: (value) => {
            if (value !== this.customer.outer_code) {
              return '輸入的識別編號不符合，請確認後重新輸入';
            }
          },
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#6c757d',
          confirmButtonText: '永久刪除',
          cancelButtonText: '取消'
        });

        if (result.value) {
          await customerApi.deleteCustomer(this.customer.id);

          this.$swal("刪除成功", "會員已成功永久刪除", "success");

          this.$router.push({ name: 'CustomerList' });
        }
      } catch (error) {
        console.error('Permanent delete customer error:', error);
        this.$swal("刪除失敗", "永久刪除會員時發生錯誤，請稍後再試", "error");
      }
    },
    async handleSoftDelete() {
      try {
        const result = await this.$swal({
          title: '刪除會員帳號',
          html: `注意：<strong style="color: #d33; font-size: 1.1em;">${this.customer.name}</strong> 帳號一旦刪除，相關資訊將無法回復。<br><br>` +
                `請輸入下方 <strong>識別編號</strong> 以確認操作：<br>` +
                `<div style="margin-top: 10px; padding: 5px; text-align: center;">` +
                `<span id="outer-code-copy-btn-2" onclick="navigator.clipboard.writeText('${this.customer.outer_code}').then(function(){ document.getElementById('outer-code-copy-btn-2').innerText = '已複製 ✔'; setTimeout(function(){ document.getElementById('outer-code-copy-btn-2').innerText = '${this.customer.outer_code}'; }, 1500); })" style="background-color: #f4f6f8; border: 1px dashed #ccc; padding: 4px 8px; border-radius: 4px; font-size: 1rem; font-weight: bold; color: #d33; letter-spacing: 1px; cursor: pointer; display: inline-block; min-width: 140px; user-select: none; transition: 0.3s;" title="點擊即可複製">${this.customer.outer_code}</span>` +
                `<div style="margin-top: 8px; font-size: 0.85rem; color: #888;">點擊上方編號即可自動複製</div></div>`,
          type: 'warning',
          input: 'text',
          inputPlaceholder: '請輸入識別編號',
          inputValidator: (value) => {
            if (value !== this.customer.outer_code) {
              return '輸入的識別編號不符合，請確認後重新輸入';
            }
          },
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#6c757d',
          confirmButtonText: '刪除',
          cancelButtonText: '取消'
        });

        if (result.value) {
          await customerApi.softDeleteCustomer(this.customer.id);

          this.$swal("刪除成功", "會員已成功刪除", "success");

          this.$router.push({ name: 'CustomerList' });
        }
      } catch (error) {
        console.error('Soft delete customer error:', error);
        this.$swal("刪除失敗", "刪除會員時發生錯誤，請稍後再試", "error");
      }
    },
  },
}
</script>

<style scoped>
.customer-name-underline {
    color: var(--primary);
}

.customer-name {
    color: black;
}
</style>
